const applyValueConstrains = function (e, value) {
    value = e.hasAttribute('min') ? Math.max(value, e.getAttribute('min')) : value
    value = e.hasAttribute('max') ? Math.min(e.getAttribute('max'), value) : value
    return value
}

export default context => {
    $(context).on('input', '.numeric', function() {
        this.value = !!this.value && Math.abs(this.value) >= 0 // not empty and is not NaN
            ? applyValueConstrains(this, this.value)
            : null
    })
}
